import * as type from '../ActionTypes';

const initialState = {
  selectedTab_coderDashboard: '1',
  selectedTab_ClientDashboard: '1'
};

export default function jobsTabs(state = initialState, action: any) {
  switch (action.type) {
    case type.SET_JOB_TAB_INDEX:
      return {
        ...state,
        selectedTab_coderDashboard: action.payload
      };
    case type.SET_CLIENT_JOB_TAB_INDEX:
      return {
        ...state,
        selectedTab_ClientDashboard: action.payload
      };
    case type.RESET_JOB_TAB_INDEX:
      return {
        ...state,
        selectedTab_coderDashboard: '1',
        selectedTab_ClientDashboard: '1'
      };
    default:
      return state;
  }
}
